import { useCallback, useState, useEffect } from "react";
import { BuildingModel } from "../models/building.model";
import { useUserContext } from "../../user/contexts/user.context";
import { BuildingService } from "../services/building.service";
import { useIonViewWillEnter } from "@ionic/react";

export const useBuilding = (buildingId: string) => {
  const [building, setBuilding] = useState<BuildingModel | null>(null);
  const { currentOrganization, hasUser } = useUserContext();
  const orgaCode = currentOrganization?.code;

  const fetchBuilding = useCallback(
    () => {
      if (!orgaCode) return Promise.resolve();
      return BuildingService.getBuilding(orgaCode, buildingId).then(setBuilding);
    },
    [orgaCode, buildingId, setBuilding]
  );

  // Charger le building dès que l'organisation est disponible
  useEffect(() => {
    if (hasUser && orgaCode) {
      fetchBuilding();
    }
  }, [hasUser, orgaCode, fetchBuilding]);

  useIonViewWillEnter(() => {
    if (orgaCode) {
      fetchBuilding();
    }
  });

  return {
    building,
    fetchBuilding,
  };
};
